<template>
    <div>
     <!--  <b-alert show class="center" variant="warning" v-if="time<12"> The data is updated daily after 12:00.</b-alert> -->
    <b-card>
        <div>
          <b-row>
            <b-col sm="6">
              <h4 id="traffic" class="card-title mb-0">Total Datas</h4>
            </b-col>
            <b-col sm="6">
              <h4 id="traffic" class="card-title mb-0" v-if="selectedOverview === 'pageview'">  Total Pageview for {{selectedOption}} : {{generalTotal}}K ({{filterDates.length}} days)  </h4>
              <h4 id="traffic" class="card-title mb-0" v-else-if="selectedOverview === 'user'">  Total Users for {{selectedOption}} : {{generalTotal}}K ({{filterDates.length}} days)  </h4>
              <h4 id="traffic" class="card-title mb-0" v-else-if="selectedOverview === 'session'"> Total Sessions for {{selectedOption}} : {{generalTotal}}K ({{filterDates.length}} days) </h4>
              <h4 id="traffic" class="card-title mb-0" v-else-if="selectedOverview === 'bouncerate'">  Avg. Bounce Rate for {{selectedOption}} : {{generalTotal}}% ({{filterDates.length}} days) </h4>
              <h4 id="traffic" class="card-title mb-0" v-else-if="selectedOverview === 'pageviewpersession'">  Total Pageview per Session for {{selectedOption}} : {{generalTotal}} ({{filterDates.length}} days) </h4>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col sm="3">
              <label for="month1">Overviews</label>
              <b-form-select id="month1"  v-model="selectedOverview" :plain="true" :options="overviewOptions">
              </b-form-select>  
            </b-col>
              <b-col sm="3">
              <label for="month2">Sites</label>
              <v-select id="month2" :on-change="change" v-model="siteSelected" :multiple=true :options="siteOptions"></v-select>
            </b-col>
            <b-col sm="3">
              <label for="choices">Options</label>
                <b-form-select id="choices"  v-model="selectedOption" :plain="true" :options="siteSelected.includes('onediocom')?['Platform','Source','Category']:['Platform','Source']">
              </b-form-select> 
            </b-col>
            <b-col sm="3">
              <label for="month3" v-if="selectedOption==='Platform'">Platforms</label>
              <v-select v-if="selectedOption==='Platform'" id="month3" :on-change="change" v-model="selectedPlatform" :multiple=true  label="text" :options="platformOptions"></v-select>
               <label for="month4" v-if="selectedOption==='Source'">Sources</label>
              <v-select v-if="selectedOption==='Source'" id="month4" :on-change="change" v-model="selectedSource" :multiple=true :options="sourceOption"></v-select>
              <label for="month5"  v-if="selectedOption==='Category'">Categories</label>
              <v-select  v-if="selectedOption==='Category'" id="month5" :on-change="change" v-model="selectedCategory" :multiple=true :options="categoryOptions"></v-select>
            </b-col>
          </b-row>
          <div v-if="loaderStatus">
            <loader :loading="loading"></loader>
          </div>
          <div v-if="chartStatus">
            <traffic-data-chart chartId="main-chart-01" class="chart-wrapper"
              style="height:300px;margin-top:40px;" :renderData=renderCommand :overview=selectedOverview :selectedSites=siteSelected :selectedPlatform=selectedPlatform
      :selectedCategory=selectedCategory
      :selectedSource=selectedSource 
      :selectedOption=selectedOption height="300" ></traffic-data-chart>
          </div>
        </div>
      </b-card>
    <b-card>
      <traffic-data-table :renderData=renderData :selectedSites=siteSelected :selectedOverview=selectedOverview
      :selectedPlatform=selectedPlatform
      :selectedCategory=selectedCategory
      :selectedSource=selectedSource 
      :selectedOption=selectedOption />
    </b-card>
    </div>
</template>
<script>
  import CardBarChartExample from './dashboard/CardBarChartExample'
  import BarBouncerate from './dashboard/BarBouncerate'
  import JWT from 'jsonwebtoken'
  import loader from 'vue-spinner/src/PulseLoader'
  import Dateformatter from '../plugins/dateFormatter'
  import AllComponent from './dashboard/MainChartAllSites'
  import {
    parse
  } from 'path'
  import numeral from 'numeral'
  import TrafficDataTable from './base/TrafficDataTable'
  import PieChartUser from '../views/charts/PieChartUser'
  import PieChartPageview from '../views/charts/PieChartPageview'
  import PieChartSession from '../views/charts/PieChartSession'
  import dateFormatter from '../plugins/dateFormatter'
  import PieChartRate from '../views/charts/PieChartRate';
  import format from 'date-fns/format'
  import { store } from '../store'
  import getTrafficDataAttributes from '../plugins/getTrafficDataAttributes'
  import TrafficDataChart from './TrafficDataChart'
  export default {
    name: 'TrafficData',
    props:[],
    components: {
      CardBarChartExample,
      TrafficDataTable,
      loader,
      PieChartUser,
      PieChartPageview,
      PieChartSession,
      PieChartRate,
      AllComponent,
      TrafficDataChart
    },
    data: function () {
      return {
        selectedOption:'Platform',
        isloading: false,
        dataDate: '',
        pageView: 0,
        session: 0,
        users: 0,
        rates:0,
        comUsers:0,
        comPageView:0,
        comSession:0,
        comRates:0,
        coUsers:0,
        coPageView:0,
        coSession:0,
        coRates:0,
        ruUsers:0,
        ruPageView:0,
        ruSession:0,
        ruRates:0,
        renderCommand: 0,
        loading: true,
        chartStatus: false,
        loaderStatus: true,
        loaderOverviews:true,
        pieChartStatus:false,
        minDate: '2018/8/7',
        startDate: '2018/8/7',
        endDate: '',
        totalRevenue: 0,
        siteOptions: ['onediocom', 'onedioru', 'onedioco'],
        siteSelected: ['onediocom'],
        request: false,
        generalTotal: 0,
        filterDates:[],
        dateFormat: 'D MMM',
        newdateFormat:'YYYY-MM-DD',
        dateOne: '',
        dateTwo: '',
        chart_data:false,
        time:'',
        uniqueAttributes:[],
        categoryOptions:[],
        overviewOptions:[{text:'Pageview',value:'pageview'},
        {text:'User',value:'user'},
        {text:'Session',value:'session'},
        {text:'Pageview per Session',value:'pageviewpersession'},
        {text:'Bounce Rate',value:'bouncerate'},],
        platformOptions:[],
        sourceOption:[],
        selectedPlatform:['No Platform'],
        selectedSource:['No Source'],
        selectedCategory:['No Category'],
        selectedOverview:'pageview',
        renderData:0,
      }
    },
    
    methods: {
      async change(e) {
       /*  await this.renderCommand++; */
        await this.$events.listen('SET_GENERAL_TOTAL_TRAFFIC', generalTotal => {
          this.generalTotal=generalTotal
        });
        await this.$events.listen('SET_DATES_TRAFFIC',dates => {
           this.filterDates=dates
         })
        
      },
    async setChartData(){
      this.chartStatus = await false,
      this.loaderStatus = await true,
      this.pieChartStatus=await false
      this.loaderOverviews=await true
        /* await this.renderCommand++; */
        await this.$events.listen('SET_GENERAL_TOTAL_TRAFFIC', generalTotal => {
                  this.generalTotal=generalTotal
                });
      await this.$events.listen('SET_DATES_TRAFFIC',dates => {
           this.filterDates=dates
         })
      this.chartStatus = await true
      this.loaderStatus = await false
      this.pieChartStatus=await true
      this.loaderOverviews=await false
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = ''
      if (dateOne) {
        formattedDates = format(dateOne, this.newdateFormat)
      }
      if (dateTwo) {
        formattedDates += ' - ' + format(dateTwo, this.newdateFormat)
      }
      return formattedDates
    },
    }
    ,
    async created() {
      
      this.time=new Date()
      this.time=Number(format(this.time,'H'))
      this.uniqueAttributes=(await getTrafficDataAttributes()).data
      this.categoryOptions=this.uniqueAttributes.category
      this.sourceOption=this.uniqueAttributes.source
      this.platformOptions=this.uniqueAttributes.platform
       if(!this.$store.state.selectedSites.length){
        this.siteSelected=['onediocom']
      }
      else{
        this.siteSelected=await this.$store.state.selectedSites
      }
        if(!this.$store.state.trafficData['filterDates']){
          await this.$store.dispatch('SET_REQUEST',true)
          await this.$store.dispatch('SET_TRAFFIC_DATA_WEEKLY')
          await this.$events.fire('SET_DATES_TRAFFIC',this.$store.state.trafficData.filterDates)
        }
        else{
          this.filterDates=await this.$store.state.trafficData.filterDates
        }
       
       await this.$events.listen('SET_GENERAL_TOTAL_TRAFFIC', generalTotal => {
                  this.generalTotal=generalTotal
                });
                /* await this.renderData++ */
                await this.renderCommand++
                await this.setChartData()
    },
     async mounted() {
       this.time=new Date()
      this.time=Number(format(this.time,'H'))
      numeral.defaultFormat('0,0');
     
        if(!this.filterDates.length){
          await this.$events.listen('SET_DATES_TRAFFIC',dates => {
           this.filterDates=dates
         })
        }
        else{
         this.filterDates=await this.$store.state.trafficData.filterDates
        }
         await this.$events.listen('SET_GENERAL_TOTAL_TRAFFIC', generalTotal => {
                  this.generalTotal= generalTotal
                });
         await this.setChartData()
      
    },  
    watch: {
    },
  }
</script>

<style scoped>
  #datepicker-trigger{
    width: 250px;
  }
  .half-left{
    width: 100%;
    float: left;
    text-align:right;
  }
  .half-right{
    width: 50%;
    float: left;
    text-align:left;
  }
  .loader{
    color: '#000000'
    
  }
  .center{
    text-align:center;
  }

</style>